<template>
  <v-card
    rounded="sm"
    outlined
    class="w-100 pointer-on-hover"
    :class="{
      'nitro' : activeTab == question.key,
      'grey' : !question.user_answer ,
      'marker' : question.user_answer && activeTab != question.key ,
    }"
    @click="$emit('click')"
  >
    <div
      class="text-white text-center marker-number d-flex align-center justify-center"
    >
      {{ question.key + 1 }}
    </div>
    <div class="bg-white text-uppercase text-center marker-answer d-flex align-center justify-center">
      {{ question.user_answer }}
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MarkerComponentInput',
  props: {
    question: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    },
    
  },
  computed:{
    ...mapGetters(['authUser']),
  },
}
</script>
<style scoped>
.marker{
  background: #8280bf;
}
.marker-number{
  min-height: 22px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.marker-answer{
  min-height: 22px;
  background: #f5f5f5;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>

